export function useAiAssistantSimpleTasksAnnouncement() {
  return {
    heading: 'Introducing AI Assistant Simple Tasks',
    imageUrl: 'ai-assistant-simple-tasks-announcement.png',
    imageAlt: 'AI Assistant Simple Tasks',
    bodyText:
      'Create and update entities, people, holdings, and dispositions with the AI Assistant',
    actionButtons: null,
  };
}
